import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
import { connect } from "react-redux";
import firebase from "firebase";
import {
  Button,
  Modal,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Image,
  Glyphicon
} from "react-bootstrap";
import Geosuggest from "react-geosuggest";
import { editar } from "../../redux/actions/cadastro";
import {
  Nome,
  Email,
  Senha,
  Logo,
  Categoria,
  Rua,
  Cidade,
  Cep,
  Cnpj,
  Fone,
  Face,
  Site,
  RuaAuto,
  CidadeAuto
} from "../../redux/actions/cadastroInputs";
function FieldGroup({ id, label, help, ...props }) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  );
}

class MdCadastro extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      isOpen: false,
      category: [],
      lat: 0,
      lng: 0
    };
  }
  componentWillMount() {
    var config = {
      apiKey: "AIzaSyByyhlriK2-7mtXbEqg-x97c42zWVfJMiE",
      authDomain: "tourbrazil-41fbe.firebaseapp.com",
      databaseURL: "https://tourbrazil-41fbe.firebaseio.com",
      projectId: "tourbrazil-41fbe",
      storageBucket: "tourbrazil-41fbe.appspot.com",
      messagingSenderId: "927605208400"
    };

    if (!firebase.apps.length) {
      firebase.initializeApp(config);
    }
    if (this.activeLocation()) {
      console.log("try");
    }
    this.getCategory();
  }
  componentDidMount() {
    this.getDateUserActive();
  }
  async endereco(lat, lng) {
    return fetch(
      "http://nominatim.openstreetmap.org/reverse?lat=" +
        lat +
        "&lon=" +
        lng +
        "&format=json"
    )
      .then(response => response.json())
      .then(responseJson => {
        this.props.RuaAuto(responseJson.address.road);
        this.props.CidadeAuto(responseJson.address.city);
      })
      .catch(err => {
        console.log(err);
      });
  }

  activeLocation() {
    function getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      } else {
        this.setState({ statusLocation: "inativa" });
        return false;
      }
    }
    const showPosition = position => {
      // this.setState({
      //   lat: position.coords.latitude,
      //   lng: position.coords.longitude
      // });
      this.endereco(position.coords.latitude, position.coords.longitude);
      this.setState({
        statusLocation: "Ok",
        lat: position.coords.latitude,
        lng: position.coords.longitude
      });
      return true;
    };
    getLocation();
  }

  getCategory() {
    const markers = firebase.database().ref("categorias");
    markers.on("value", snapshot => {
      const category = [];
      snapshot.forEach(e => {
        const name = e.child("nome").val();
        category.push(name);
      });
      this.setState({ category: category });
    });
  }

  handleClose() {
    console.log("fecha");
    this.setState({ show: false });
  }

  handleShow() {
    console.log("aberto");
    this.setState({ show: true });
  }
  getDateUserActive() {
    firebase.auth().onAuthStateChanged(user => {
      var id = user.uid;
      var email = user.email;
      var markers = firebase
        .database()
        .ref("empDados/" + id)
        .orderByKey();
      markers.on("value", snapshot => {
        var data = snapshot.val();
        this.props.Nome(data.nome);
        this.props.Email(email);
        this.props.Categoria(data.cat);
        this.props.Rua(data.morada1);
        this.props.Cidade(data.morada2);
        this.props.Cep(data.codPostal);
        this.props.Cnpj(data.cnpj);
        this.props.Fone(data.fone);
        this.props.Face(data.facebook);
        this.props.Site(data.link);
        this.setState({ oldImg: data.img, lat: data.lat, lng: data.lng });
      });
    });
  }
  render() {
    return (
      <div>
        <div className={css(styles.item)} onClick={this.handleShow}>
          <Glyphicon className={css(styles.icones)} glyph="user" /> Editar
          Perfil
        </div>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Editar Perfil</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <FieldGroup
                id="formControlsText"
                type="text"
                label="Nome / Empresa"
                placeholder="Ex: Sua Empresa"
                onChange={e => this.props.Nome(e.target.value)}
                value={this.props.nome}
              />

              {/* <FieldGroup
                id="formControlsEmail"
                type="email"
                label="E-mail"
                placeholder="Ex: email@servidor.com"
                onChange={e => this.props.Email(e.target.value)}
                value={this.props.email}
              />
              <FieldGroup
                id="formControlsPassword"
                label="Senha"
                type="password"
                placeholder="Crie uma senha de acesso"
                onChange={e => this.props.Senha(e.target.value)}
                value={this.props.senha}
              /> */}

              {/* <FieldGroup
                id="formControlsFile"
                type="file"
                label="Logotipo"
                help="Obs: Essa imagem será usada no seu Perfil e será mostrada para os Viajantes."
                onChange={e => this.props.Logo(e)}
              /> */}
              <label>Logotipo</label>
              <div>
                <label for="file-input" className={css(styles.changePhoto)}>
                  <Glyphicon
                    className={css(styles.iconeCamera)}
                    glyph="camera"
                  />{" "}
                  Selecionar Imagem
                </label>

                <input
                  className={css(styles.uploadimg)}
                  id="file-input"
                  type="file"
                  onChange={e => this.props.Logo(e)}
                />
              </div>
              {this.props.cadastroState === "Aguarde, Enviando Imagem..."
                ? this.props.cadastroState
                : ""}
              <Image src={this.props.logotipo} width="50px" circle responsive />

              <FormGroup
                controlId="formControlsSelect"
                onChange={e => this.props.Categoria(e.target.value)}
              >
                <ControlLabel>Categoria</ControlLabel>
                <FormControl componentClass="select" placeholder="Categoria">
                  <option value="select">
                    Selecione a categoria que melhor define sua empresa
                  </option>
                  {this.state.category.map(e => {
                    return (
                      <option value={e} key={e + "cat"}>
                        {e}
                      </option>
                    );
                  })}
                </FormControl>
              </FormGroup>
              {/* <FieldGroup
                id="formControlsRua"
                type="text"
                label="Rua"
                placeholder="Rua Fulano de Tal, 123"
                onChange={e => this.props.Rua(e.target.value)}
                value={this.props.rua}
              /> */}
              <label>Rua</label>
              <Geosuggest
                placeholder={this.props.rua}
                minLength={5}
                country="br"
                types={["geocode"]}
                // location={[this.state.lat, this.state.lng]}
                // radius={50}
                onSuggestSelect={e => {
                  this.props.Rua(e.label);
                  this.setState({ lat: e.location.lat });
                  this.setState({ lng: e.location.lng });
                }}
                style={{
                  input: {
                    width: "100%",
                    height: "34px",
                    padding: "6px 12px",
                    borderColor: "",
                    fontSize: "14px",
                    lineHeight: 1.42857143,
                    color: "#555",
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "4px"
                  },
                  suggests: {
                    listStyle: "none"
                  },
                  suggestItem: {
                    cursor: "pointer",
                    backgroundColor: "#90909",
                    padding: "5px"
                  }
                }}
              />
              <FieldGroup
                id="formControlsCidade"
                type="text"
                label="Cidade"
                placeholder="Em qual Cidade sua empresa está localizada?"
                onChange={e => this.props.Cidade(e.target.value)}
                value={this.props.cidade}
              />
              {/* <FieldGroup
                id="formControlsLatitude"
                type="number"
                label="Latitude"
                placeholder="Informe a Latitude da sua empresa no GoogleMaps"
                onChange={e => this.setState({ lat: e.target.value })}
                value={this.state.lat}
              />
              <FieldGroup
                id="formControlsLongitude"
                type="number"
                label="Longitude"
                placeholder="Informe a Longitude da sua empresa no GoogleMaps"
                onChange={e => this.setState({ lng: e.target.value })}
                value={this.state.lng}
              /> */}
              <FieldGroup
                id="formControlsCEP"
                type="number"
                label="CEP"
                placeholder="Qual o CEP da sua Empresa?"
                onChange={e => this.props.Cep(e.target.value)}
                value={this.props.cep}
              />
              <FieldGroup
                id="formControlsCNPJ"
                type="text"
                label="CNPJ"
                placeholder="Qual seu CNPJ."
                onChange={e => this.props.Cnpj(e.target.value)}
                value={this.props.cnpj}
              />
              {this.props.cnpjValidate}
              <FieldGroup
                id="formControlsFone"
                type="number"
                label="Telefone"
                placeholder="Telefone que os Viajantes usarão para entrar em contato com você."
                onChange={e => this.props.Fone(e.target.value)}
                value={this.props.fone}
              />
              <FieldGroup
                id="formControlsFace"
                type="text"
                label="Página do Facebook"
                placeholder="https://www.facebook.com/sua-pagina"
                onChange={e => this.props.Face(e.target.value)}
                value={this.props.face}
              />
              <FieldGroup
                id="formControlsWeb"
                type="text"
                label=" Site da Empresa"
                placeholder="www.meusite.com.br"
                onChange={e => this.props.Site(e.target.value)}
                value={this.props.site}
              />

              {this.props.cadastroState === "Aguarde, Enviando Imagem..." ||
              this.props.cadastroState === "Iniciando Cadastro" ? (
                <Button
                  className="btn btn-primary btn-block"
                  type="submit"
                  bsStyle="success"
                  disabled
                >
                  Finalizar Edição
                </Button>
              ) : (
                <Button
                  className="btn btn-primary btn-block"
                  type="submit"
                  bsStyle="success"
                  onClick={() =>
                    this.props.editar(
                      this.props.nome,
                      this.props.logotipo,
                      this.props.categoria,
                      this.props.rua,
                      this.props.cidade,
                      this.props.cep,
                      this.props.cnpj,
                      this.props.fone,
                      this.props.face,
                      this.props.site,
                      this.state.lat,
                      this.state.lng,
                      this.state.oldImg
                    )
                  }
                >
                  Finalizar Edição
                </Button>
              )}

              {this.props.cadastroState}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-default btn-block"
              onClick={this.handleClose}
            >
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
const styles = StyleSheet.create({
  item: {
    cursor: "pointer"
  },
  icones: {
    fontSize: "18px",
    verticalAlign: "sub",
    marginRight: "3px"
  },
  iconeCamera: {
    fontSize: "25px",
    verticalAlign: "sub",
    marginRight: "3px"
  },
  uploadimg: {
    display: "none"
  },
  changePhoto: {
    cursor: "pointer"
  }
});
const mapStateToProps = state => {
  return {
    user: state.user.user,
    nome: state.cadastro.nome,
    email: state.cadastro.email,
    emailValidate: state.cadastro.emailValidate,
    senha: state.cadastro.senha,
    senhaValidate: state.cadastro.senhaValidate,
    logotipo: state.cadastro.logotipo,
    categoria: state.cadastro.categoria,
    rua: state.cadastro.rua,
    cidade: state.cadastro.cidade,
    cep: state.cadastro.cep,
    cnpj: state.cadastro.cnpj,
    cnpjValidate: state.cadastro.cnpjValidate,
    fone: state.cadastro.fone,
    face: state.cadastro.face,
    site: state.cadastro.site,
    cadastroState: state.cadastro.cadastroState
  };
};
export default connect(
  mapStateToProps,
  {
    editar,
    Nome,
    Email,
    Senha,
    Logo,
    Categoria,
    Rua,
    Cidade,
    Cep,
    Cnpj,
    Fone,
    Face,
    Site,
    RuaAuto,
    CidadeAuto
  }
)(MdCadastro);



// WEBPACK FOOTER //
// ./src/assets/modalEditarPefil/index.js